import { LoadingBox } from '@outbound-ai/ursa'
import { CallChat } from 'features/calls/components/CallChat'
import { ICall } from 'features/calls/types'
import { IClaim } from 'features/claims/types'
import { ObModal } from '@outbound-ai/ursa'

import { useTheme } from 'styled-components'

interface IProps {
  claim: IClaim
  call: ICall | null
  show: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>

  isLoadingStartCall: boolean
}
export const TestCallChatModal = ({ claim, call, show, setShow }: IProps) => {
  const theme = useTheme()

  const callChatStyles = `
  border: 1px solid ${theme.colors.primary.lightest};
  max-height: ${theme.util.pixelToRem(620)};
  height: ${theme.util.pixelToRem(620)};
  width: ${theme.util.pixelToRem(724)};
  .body{
    height: ${theme.util.pixelToRem(550)};
    .messages {
      height: ${theme.util.pixelToRem(451)};
    }
  }
  `

  return (
    <div>
      <ObModal
        show={show}
        close={() => setShow(false)}
        size="xl"
        customSize="large"
        title={`Test Call in Progress`}
        height="auto"
        hideCloseButton={true}
      >
        {!call && <LoadingBox />}
        {call && <CallChat claim={claim} call={call} styles={callChatStyles} />}
      </ObModal>
    </div>
  )
}
